import api from '../../../../utils/api';

const deleteExtraDocument = async (filename: string, homeseekerId: string): Promise<unknown> => {
    return await api.deleteWithoutAuth(`api/screening/${homeseekerId}/additional-information/extra-document/delete`, {
        filename
    });
}

export default deleteExtraDocument;
